import React from 'react';
import styled from 'styled-components';

import { Contact, theme } from 'components';

import { Container } from '../common';

import { ContactDrawerTeam, ContactDrawerType } from '../../../types';
import { DRAWER_PADDING } from '../../../constants';

interface TeamMemberDetailsProps {
  teamContact: ContactDrawerTeam;
  goToContact: (type: ContactDrawerType, contactId: string) => void;
}

const TeamMemberDetails: React.FC<TeamMemberDetailsProps> = ({
  teamContact,
  goToContact,
}) => (
    <StyledContainer>
      {teamContact.users.map(user => (
        <ContactItem
          key={user.id}
          style={{ flex: 1 }}
          onClick={() => goToContact(ContactDrawerType.User, user.id)}
        >
          <Contact
            avatarSize={32}
            key={user.id}
            contact={user}
            loading={false}
            showTitle
            onClick={() => undefined}
          />
        </ContactItem>
      ))}
    </StyledContainer>
  );

export default TeamMemberDetails;

const StyledContainer = styled(Container)`
  overflow-y: auto;
  max-height: 20vh;
  padding: 0px ${DRAWER_PADDING / 2}px;
  span {
    color: ${theme.gray8};
  }
`;

const ContactItem = styled.div`
  cursor: pointer;
  padding: 8px;
  &:hover {
    background-color: ${theme.gray2};
  }
`;
